"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Icon = _interopRequireDefault(require("../icon/Icon"));

var _ImageUpload = require("./ImageUpload.style");

var _IconButton = _interopRequireDefault(require("../icon-button/IconButton"));

var _uuid = require("uuid");

var _excluded = ["className", "src", "onClick", "onChange", "fileProps", "buttonProps"];

var ImageUpload = function ImageUpload(_ref) {
  var className = _ref.className,
      src = _ref.src,
      onClick = _ref.onClick,
      onChange = _ref.onChange,
      fileProps = _ref.fileProps,
      buttonProps = _ref.buttonProps,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var uuid = (0, _uuid.v4)();
  return /*#__PURE__*/_react["default"].createElement(_ImageUpload.StyledImageWrapper, {
    className: className
  }, /*#__PURE__*/_react["default"].createElement(_ImageUpload.StyledImageInner, null, src ? /*#__PURE__*/_react["default"].createElement(_ImageUpload.StyledImage, (0, _extends2["default"])({
    src: src
  }, props)) : /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    iconName: "Image",
    size: 30
  })), /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: uuid
  }, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], (0, _extends2["default"])({
    onClick: onClick,
    component: "span",
    className: "eui-upload-button"
  }, buttonProps), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    iconName: "Upload",
    size: 18,
    fill: "white"
  }))), /*#__PURE__*/_react["default"].createElement("input", (0, _extends2["default"])({
    style: {
      display: 'none'
    },
    onChange: onChange,
    type: "file",
    id: uuid
  }, fileProps)));
};

ImageUpload.propTypes = {
  className: _propTypes["default"].string,
  src: _propTypes["default"].string,
  fileProps: _propTypes["default"].object,
  onClick: _propTypes["default"].func,
  onChange: _propTypes["default"].func,
  buttonProps: _propTypes["default"].object
};
var _default = ImageUpload;
exports["default"] = _default;